// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"e729cf8f","703":"0e374d64"}[chunkId] + ".chunk.js";
};